import React, { useState, useEffect } from "react";
import "./processlider.css";


const steps = [
  {
    id: 1,
    title: "Meet Designer",
    desc: "Connect with our expert designers to discuss your dream home.",
    image: "assets/images/first.jpeg",
  },
  {
    id: 2,
    title: "Book Project",
    desc: "Confirm your project and begin your design journey.",
    image:"assets/images/second.jpeg",
  },
  {
    id: 3,
    title: "Design Finalization",
    desc: "Finalize layouts, materials, and complete 3D designs.",
    image: "assets/images/third.jpeg",
  },
  {
    id: 4,
    title: "Production Begins",
    desc: "Your furniture and materials move into production.",
    image: "assets/images/fourth.jpeg",
  },
  {
    id: 5,
    title: "Kick Off Dispatch",
    desc: "Pay the remaining amount and dispatch your order for installation.",
    image: "/assets/images/fifth.jpeg",
  },
  {
    id: 6,
    title: "Move In",
    desc: "Installation completed successfully. Welcome to your dream home.",
    image: "/assets/images/sixth.jpeg",
  },
];


const ProcessSlider = () => {
  const [active, setActive] = useState(0);

  const nextSlide = () => {
    setActive((prev) => (prev + 1) % steps.length);
  };

  const prevSlide = () => {
    setActive((prev) => (prev - 1 + steps.length) % steps.length);
  };

  useEffect(() => {
    const interval = setInterval(() => {
      nextSlide();
    }, 5000);

    return () => clearInterval(interval);
  }, []);

  return (
  <section className="process-section">

  <div className="step-indicator">
    {steps.map((step, index) => (
      <div
        key={step.id}
        className={`step-item ${index === active ? "active" : ""}`}
        onClick={() => setActive(index)}
      >
        
        <span>{step.id}</span>
      </div>
    ))}
  </div>

  <div className="process-slider">

    <button className="arrow left" onClick={prevSlide}>
      ❮
    </button>

    <div className="slider-content">

      <div className="slider-text">
        <h2>{steps[active].title}</h2>
        <p>{steps[active].desc}</p>
      </div>

      <div className="slider-image">
        <img
          src={steps[active].image}
          alt={steps[active].title}
        />
      </div>

    </div>

    <button className="arrow right" onClick={nextSlide}>
      ❯
    </button>

  </div>

</section>
  );
};

export default ProcessSlider;